// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".flex {\n  display: flex;\n  align-items: center;\n  margin-top: 25px;\n}\n.label-box {\n  flex-shrink: 0;\n  margin-right: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
